import {
  CheckboxIndicator,
  CheckboxProps,
  Checkbox as CheckboxRoot,
} from '@radix-ui/react-checkbox';
import { clsx } from 'clsx';
import { CheckIcon } from '../icons/react/check.tsx';
import { MinusIcon } from '../icons/react/minus.tsx';
import { checkbox, checkboxIndicator } from './checkbox.css.ts';

export const Checkbox = function CheckboxComponent({
  ref,
  children,
  className,
  ...rest
}: CheckboxProps & {
  ref?: React.Ref<HTMLButtonElement>;
}) {
  return (
    <CheckboxRoot ref={ref} className={clsx(className, checkbox)} {...rest}>
      <CheckboxIndicator className={checkboxIndicator}>
        {rest.checked === 'indeterminate' ? (
          <MinusIcon width={18} height={18} />
        ) : (
          <CheckIcon width={18} height={18} />
        )}
      </CheckboxIndicator>
    </CheckboxRoot>
  );
};
